module.exports = __webpack_public_path__ + "static/media/wendy_cabrera_rubio_4.72b76f62.jpg";